<template>
  <v-container fluid>
    <!-- Tabella Materiali -->
    <v-data-table
      :headers="headers"
      fixed-header
      :items="classi_pericolosita"
      :items-per-page="10"
      item-key="id_classe_pericolosita"
      class="elevation-1 mt-5"
      calculate-widths
      height="60vh"
    >
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Classi Pericolosità
          </v-toolbar-title>
          <v-spacer />
          <!-- Pulsante apri dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="apriDialog"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
          <v-spacer />
          <div style="width: 120px;" />
        </v-toolbar>
      </template>
      <!-- Pulsante Modifica -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="
                selectItem(item);
                dialog_crea = true;
              "
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Pulsante eliminazione -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="selectItem(item), (delete_dialog = true)"
              v-bind="attrs"
              v-on="on"
              small
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <!-- Dialog creazione/modifica -->

    <v-dialog v-model="dialog_crea" persistent>
      <v-card class="pb-10">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Aggiungi </v-toolbar-title>
          <v-spacer />
          <!-- Pulsante salva materiale -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaClasse"
                class="mr-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>
          <v-spacer />
          <!-- Pulsante chiudi dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_crea = false"
                class="mr-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-row justify="center" class="mt-5">
          <v-col cols="4">
            <v-text-field
              v-model="selected_item.codice"
              label="Codice"
              dense
              hide-details
            />
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="7">
            <v-textarea
              v-model="selected_item.descrizione"
              label="Descrizione"
              dense
              rows="1"
              hide-details
            />
          </v-col>
          <v-col cols="7">
            <v-textarea
              v-model="selected_item.note"
              label="Note"
              dense
              rows="2"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- Dialog eliminazione materiale -->
    <v-dialog persistent v-model="delete_dialog">
      <v-card min-height="150px">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Pulsante conferma -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  selected_item.validita = 0;
                  salvaMateriale();
                "
                class="mr-10"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success">mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Pulsante chiudi dialog -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="delete_dialog = false"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <div class="text-center mt-10">
          Sei sicuro di voler eliminare il materiale {{ selected_item.codice }}
        </div>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
    <script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Classe {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_classe_pericolosita", default_val: null },
      { nome: "codice", default_val: "" },
      { nome: "descrizione", default_val: "" },
      { nome: "note", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}
export default {
  name: "QLClassiPericolosita",

  data() {
    return {
      // Variabili d'appoggio
      overlay: false,
      dialog_crea: false,
      delete_dialog: false,
      selected_item: new Classe(),
      // Array
      classi_pericolosita: [],
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
          width: "100px",
        },
        {
          text: "Codice",
          value: "codice",
          filterable: false,
          sortable: false,
          width: "100px",
        },
        {
          text: "Descrizione",
          value: "descrizione",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
          width: "100px",
        },
      ],
    };
  },
  components: { SnackbarQV },
  methods: {
    selectItem(item) {
      this.selected_item = JSON.parse(JSON.stringify(item));
    },
    apriDialog() {
      this.dialog_crea = true;
      this.selected_item = new Classe();
    },
    salvaClasse() {
      const saveclassepericolosita = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "saveclassepericolosita",
          classe_pericolosita: this.selected_item,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api6", saveclassepericolosita).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.delete_dialog = false;
          this.dialog_crea = false;
          this.$refs.SnackbarQV.print("success", "Classe salvata.");
          this.aggiornaItems();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },
    // "classe_pericolosita":{
    //     "data_inizio":"2023-01-01",
    //     "data_fine":null,
    // }-->

    aggiornaItems() {
      const getclassipericolosita = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "getclassipericolosita",
          id_classe_pericolosita: null,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api6", getclassipericolosita).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          console.table(res.data);
          this.classi_pericolosita = res.data.result ? res.data.result.reverse() : [];
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },
  },
  created() {},
  mounted() {
    this.aggiornaItems();
  },
};
</script>
<style scoped>
</style>